import React, { useEffect } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import veeMarker from "@/assets/images/icons/veeMarker.webp";

const containerStyle = {
  width: "400px",
  height: "180px",
  borderRadius: "12px",
};

interface LatLng {
  lat: number;
  lng: number;
  zoom?: number;
}

function MyMap({ lat, lng, zoom }: LatLng): JSX.Element {
  const { isLoaded } = useLoadScript({
    id: "google-map-script",
    googleMapsApiKey: process.env.NEXT_PUBLIC_MAPS_KEY || "",
  });

  //   const [map, setMap] = React.useState(null);

  //  const onLoad = React.useCallback(function callback(map) {
  //    // This is just an example of getting and using the map instance!!! don't just blindly copy!
  //    const bounds = new window.google.maps.LatLngBounds(center);
  //    map.fitBounds(bounds);

  //    setMap(map);
  //  }, []);

  //   const onUnmount = React.useCallback(function callback(map) {
  //     setMap(null);
  //   }, []);
  const [icon, setIcon] = React.useState<any>({
    url: veeMarker.src,
    scaledSize: "",
  });
  useEffect(() => {
    if (isLoaded) {
      setIcon({
        url: veeMarker.src,
        scaledSize: new window.google.maps.Size(40, 40),
      });
    }
  }, [isLoaded]);

  return isLoaded ?
      <GoogleMap
        mapContainerStyle={{
          ...containerStyle,
          width: window.screen.availWidth < 430 ? "325px" : "400px",
        }}
        center={{ lat, lng }}
        zoom={zoom ?? 10}
        clickableIcons={false}
        options={{ fullscreenControl: false, keyboardShortcuts: false }}
        //onLoad={onLoad}
        //onUnmount={onUnmount}
      >
        {/* Child components, such as markers, info windows, etc. */}
        <Marker
          aria-label="Activity location marker"
          onClick={() => {
            window.open(
              "https://www.google.com/maps/search/?api=1&query=" +
                lat +
                "," +
                lng,
            );
          }}
          position={{ lat, lng }}
          icon={icon}
        />
      </GoogleMap>
    : <></>;
}

export default React.memo(MyMap);
